import { useCallback } from 'react';

import { LANGUAGE_TO_DATE_FORMAT } from '@/constants/date';
import { useCurrentLanguage } from '@/utils/i18n.utils';
import { formatInAppTz } from '@/utils/spain-time';

export function useGetDateRangeFormatted() {
  const language = useCurrentLanguage();
  const dateFormat = LANGUAGE_TO_DATE_FORMAT[language];

  const getDateRangeFormatted = useCallback(
    (startTime: string, endTime: string | null) => {
      const initalDate = formatInAppTz(startTime, dateFormat);
      const endDate = endTime ? formatInAppTz(endTime, dateFormat) : null;

      if (!endDate || initalDate === endDate) {
        return initalDate;
      }

      return `${initalDate} - ${endDate}`;
    },
    [dateFormat]
  );

  return getDateRangeFormatted;
}
